import { useEffect, useState } from 'react';

/**
 * True once the page has scrolled past `threshold`. Used to condense the
 * sticky nav, which is otherwise indistinguishable from the hero behind it.
 */
export default function useScrolled(threshold = 8) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > threshold);
    onScroll();
    // Passive: this listener never calls preventDefault, and saying so keeps
    // scrolling off the main thread's critical path.
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  return scrolled;
}
